class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();

    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true, onComplete) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');

    document.getElementById('ProductGridContainer')?.querySelector('.collection-grid-container')?.classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event, onComplete)
        : FacetFiltersForm.renderSectionFromFetch(url, event, onComplete);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event, onComplete) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (document.getElementById('SortBy')) {
          document.getElementById('SortBy').dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
        if (typeof onComplete === 'function') onComplete();
      });
  }

  static renderSectionFromCache(filterDataUrl, event, onComplete) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (document.getElementById('SortBy')) {
      document.getElementById('SortBy').dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
    if (typeof onComplete === 'function') onComplete();
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderProductCount(html) {
    const countElement = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount');
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');

    if (countElement && container) {
      container.innerHTML = countElement.innerHTML;
      container.classList.remove('loading');
    }

    if (countElement && containerDesktop) {
      containerDesktop.innerHTML = countElement.innerHTML;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter');
    const facetDetailsElementsFromDom = document.querySelectorAll('#FacetFiltersForm .js-filter');

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        /*
        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
        */
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementToActivate = newFacetDetailsElement.querySelector('.facets__summary');

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    // console.log(new URLSearchParams(formData).toString());
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();

    const params = new URLSearchParams();

    const currentUrl = new URL(window.location.href);
    const sortParam = currentUrl.searchParams.get('sort_by');
    if (sortParam) {
      params.set('sort_by', sortParam);
    }

    const sortBySelect = document.getElementById('SortBy');
    if (sortBySelect && sortBySelect.value) {
      params.set('sort_by', sortBySelect.value);
    }

    const sortFilterForms = document.querySelectorAll('facet-filters-form form');

    sortFilterForms.forEach((form) => {
      const checkboxInputs = form.querySelectorAll('input[type="checkbox"]');
      checkboxInputs.forEach(input => {
        if (input.checked) {
          params.append(input.name, input.value);
        }
      });

      const otherInputs = form.querySelectorAll('input:not([type="checkbox"])');
      otherInputs.forEach(input => {
        if (input.value && input.name !== 'sort_by') {
          params.set(input.name, input.value);
        }
      });

      const selectElements = form.querySelectorAll('select');
      selectElements.forEach(select => {
        if (select.value && select.name === 'sort_by') {
          params.set('sort_by', select.value);
        }
      });
    });

    this.onSubmitForm(params.toString(), event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

// Collection pagination without a full reload; links stay real <a href> for crawlers.
document.addEventListener('click', (event) => {
  const link = event.target.closest('#ProductGridContainer .pagination a');
  if (!link || !document.getElementById('product-grid')) return;
  if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;

  event.preventDefault();
  FacetFiltersForm.renderPage(
    new URL(link.href).searchParams.toString(),
    null,
    true,
    () => {
      const gridContainer = document.getElementById('ProductGridContainer');
      if (!gridContainer) {
        console.warn("[pagination] #ProductGridContainer not found after fetch; can't scroll.");
        return;
      }
      // Wait a frame so the newly-inserted grid has been laid out before we measure/scroll to it.
      requestAnimationFrame(() => {
        gridContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    },
  );
});

// class PriceRange extends HTMLElement {
//   constructor() {
//     super();
//     this.querySelectorAll('input').forEach((element) => {
//       element.addEventListener('change', this.onRangeChange.bind(this));
//       element.addEventListener('keydown', this.onKeyDown.bind(this));
//     });
//     this.setMinAndMaxValues();
//   }

//   onRangeChange(event) {
//     this.adjustToValidValues(event.currentTarget);
//     this.setMinAndMaxValues();
//   }

//   onKeyDown(event) {
//     const allowedKeys = ['Backspace', 'Tab', 'Enter', 'ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'Delete', 'Escape'];
//     if (!allowedKeys.includes(event.key) && !/[0-9.,]/.test(event.key)) {
//       event.preventDefault();
//     }
//   }

//   setMinAndMaxValues() {
//     const inputs = this.querySelectorAll('input');
//     const minInput = inputs[0];
//     const maxInput = inputs[1];

//     if (maxInput.value) {
//       minInput.setAttribute('data-max', maxInput.value);
//     } else {
//       minInput.setAttribute('data-max', maxInput.getAttribute('max'));
//     }

//     if (minInput.value) {
//       maxInput.setAttribute('data-min', minInput.value);
//     } else {
//       maxInput.setAttribute('data-min', minInput.getAttribute('min'));
//     }
//   }

//   adjustToValidValues(input) {
//     const value = Number(input.value);
//     const min = Number(input.getAttribute('min')) || 0; // Default to input's min attribute
//     const max = Number(input.getAttribute('max')); // Default to input's max attribute

//     if (!isNaN(min) && value < min) input.value = min;
//     if (!isNaN(max) && value > max) input.value = max;
//   }
// }
class PriceRange extends HTMLElement {
  constructor() {
    super();
    // Separate range sliders from number inputs
    this.rangeInputs = Array.from(this.querySelectorAll(".range-slider-input"));
    this.numberInputs = Array.from(this.querySelectorAll('input[type="number"]'));
    this.rangeSlider = this.querySelector(".range-slider");

    // Range sliders: live visual update while dragging, filter fetch on release
    this.rangeInputs.forEach((el) => {
      el.addEventListener("input", this.onRangeInput.bind(this));
      el.addEventListener("change", this.onRangeCommit.bind(this));
    });

    // Number inputs: sync sliders while typing (input) and trigger fetch on commit (change)
    this.numberInputs.forEach((el) => {
      el.addEventListener("input", this.onNumberInput.bind(this));
      el.addEventListener("change", this.onNumberChange.bind(this));
      el.addEventListener("keydown", this.onKeyDown.bind(this));
    });

    this.initValues();
  }

  /** Seed sliders from rendered number-input values on page load */
  initValues() {
    const minVal = parseFloat(this.numberInputs[0]?.value) || 0;
    const maxAttr = this.numberInputs[1]?.getAttribute("max");
    const maxVal = parseFloat(this.numberInputs[1]?.value) || parseFloat(maxAttr) || 0;

    if (this.rangeInputs[0]) this.rangeInputs[0].value = minVal;
    if (this.rangeInputs[1]) this.rangeInputs[1].value = maxVal;

    this.setMinAndMaxValues();
    this.updateRangeProgress();
  }

  /** Live update while dragging — syncs number inputs, updates gradient */
  onRangeInput(event) {
    const isMin = event.currentTarget === this.rangeInputs[0];
    let minVal = parseFloat(this.rangeInputs[0].value) || 0;
    let maxVal = parseFloat(this.rangeInputs[1].value) || 0;

    // Prevent thumbs from crossing each other
    if (isMin && minVal >= maxVal) {
      this.rangeInputs[0].value = maxVal - 1;
      minVal = maxVal - 1;
    } else if (!isMin && maxVal <= minVal) {
      this.rangeInputs[1].value = minVal + 1;
      maxVal = minVal + 1;
    }

    if (this.numberInputs[0]) this.numberInputs[0].value = minVal;
    if (this.numberInputs[1]) this.numberInputs[1].value = maxVal;

    this.updateRangeProgress();
  }

  /** On thumb release — update bounds metadata and fire filter fetch */
  onRangeCommit() {
    this.setMinAndMaxValues();
    // Bubble a change event from the min number input so FacetFiltersForm triggers
    if (this.numberInputs[0]) {
      this.numberInputs[0].dispatchEvent(new Event("change", { bubbles: true }));
    }
  }

  /** Live slider sync while the user is actively typing — no filter fetch */
  onNumberInput() {
    this.syncSlidersFromInputs();
    this.updateRangeProgress();
  }

  /** User committed a number input (blur / Enter) — clamp + fetch */
  onNumberChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.syncSlidersFromInputs();
    this.setMinAndMaxValues();
    this.updateRangeProgress();
  }

  /** Mirror current number-input values into the range sliders */
  syncSlidersFromInputs() {
    const minVal = parseFloat(this.numberInputs[0]?.value) || 0;
    const maxVal = parseFloat(this.numberInputs[1]?.value) || 0;
    if (this.rangeInputs[0]) this.rangeInputs[0].value = minVal;
    if (this.rangeInputs[1]) this.rangeInputs[1].value = maxVal;
  }

  /** Update the CSS gradient track between the two thumbs */
  updateRangeProgress() {
    if (!this.rangeSlider || !this.rangeInputs[0] || !this.rangeInputs[1]) return;
    const max = parseFloat(this.rangeInputs[0].getAttribute("max")) || 100;
    const minPct = (parseFloat(this.rangeInputs[0].value) / max) * 100;
    const maxPct = (parseFloat(this.rangeInputs[1].value) / max) * 100;
    this.rangeSlider.style.setProperty("--range-min", `${minPct}%`);
    this.rangeSlider.style.setProperty("--range-max", `${maxPct}%`);
  }

  /** Keep data-min / data-max in sync for cross-bound validation */
  setMinAndMaxValues() {
    if (!this.numberInputs[0] || !this.numberInputs[1]) return;
    const minInput = this.numberInputs[0];
    const maxInput = this.numberInputs[1];

    minInput.setAttribute("data-max", maxInput.value || maxInput.getAttribute("max"));
    maxInput.setAttribute("data-min", minInput.value || minInput.getAttribute("min"));
  }

  /** Clamp a number input inside its valid range */
  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute("data-min") || input.getAttribute("min")) || 0;
    const max = Number(input.getAttribute("data-max") || input.getAttribute("max"));

    if (!isNaN(min) && value < min) input.value = min;
    if (!isNaN(max) && value > max) input.value = max;
  }

  /** Block non-numeric key presses in number inputs */
  onKeyDown(event) {
    const allowedKeys = ["Backspace","Tab","Enter","ArrowUp","ArrowDown","ArrowLeft","ArrowRight","Delete","Escape"];
    if (!allowedKeys.includes(event.key) && !/[0-9.,]/.test(event.key)) {
      event.preventDefault();
    }
  }
}


customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);
